export default {
    edit: "Уреди",
    location: "Локација + Услови и услови",
    filter: "Филтер"
}
